<template>
  <router-view />
</template>

<script>
import "bootstrap-vue/dist/bootstrap-vue.css";
import "bootstrap/dist/css/bootstrap.css";
import "devextreme/dist/css/dx.light.css";
import "vue-select/dist/vue-select.css";
import "vue-toastification/dist/index.css";
import "@/assets/icomoon/style.css";

export default {};
</script>

<style lang="sass">
@import "@/assets/styles/style"
</style>
